import { render, staticRenderFns } from "./HomeV3.vue?vue&type=template&id=5d2effa5&scoped=true"
import script from "./HomeV3.vue?vue&type=script&lang=js"
export * from "./HomeV3.vue?vue&type=script&lang=js"
import style0 from "./HomeV3.vue?vue&type=style&index=0&id=5d2effa5&prod&lang=css"
import style1 from "./HomeV3.vue?vue&type=style&index=1&id=5d2effa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2effa5",
  null
  
)

export default component.exports